import { AntenneForPerimetreCAC } from './antenne-for-perimetre-cac.entity';

export class AgenceForPerimetreCAC {
	id!:  number;
	nom!: string;
	antennes: AntenneForPerimetreCAC[] = [];

	constructor() {
	}
}